module.exports = __webpack_public_path__ + "static/media/icon_dispatch.8db250a3.png";